// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1g6GL","questions":"styles_questions__2xoQf","footer":"styles_footer__1zbRi"};